import React, { useEffect, useState, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Traductor } from "../Componentes/Traductor";
import { Formatofecha } from "../Componentes/Formatofecha";
import EditarBillOfLadingModal from "./EditarBLModal";
import AsociarPedBillOfLadingModal from "./AsociarPedBillOfLadingModal";

import "../styles/ListaContenedores.css";
import { fetchWithAuth, API_URL } from "../Componentes/fetchWithAuth";

const ListaBillOfLading = ({ language }) => {
  const [billOfLadings, setBillOfLadings] = useState([]);
  const [filteredBillOfLadings, setFilteredBillOfLadings] = useState([]);
  const [isEditModalBillOfLadingOpen, setEditModalBillOfLadingOpen] =
    useState(false);
  const [selectedBillOfLading, setSelectedBillOfLading] = useState(null);
  const [searchText, setSearchText] = useState("");
  const toastCenter = useRef(null);
  const translations = Traductor(language);

  const translationsResultForColumns = Traductor(language);
  const columnsBillOfLading =
    translationsResultForColumns && translationsResultForColumns.columnsBL
      ? translationsResultForColumns.columnsBL
      : [];

  useEffect(() => {
    fetchWithAuth(`${API_URL}/api/billoflading`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Error en la respuesta del servidor");
        }
        return response.json();
      })
      .then((data) => {
        const processedData = Array.isArray(data) ? data : [];
        setBillOfLadings(processedData);
        setFilteredBillOfLadings(processedData);
      })
      .catch((err) => {
        console.error("Error al cargar los BillOfLading:", err);
      });
  }, []);

  const showMessage = (severity, summary, detail) => {
    if (toastCenter.current) {
      toastCenter.current.show({ severity, summary, detail, life: 3000 });
    }
  };

  const handleEditBillOfLading = () => {
    if (
      selectedBillOfLading &&
      selectedBillOfLading.NombreEstado &&
      ["creado", "asignado", "plan_de_cargue"].includes(
        selectedBillOfLading.NombreEstado.toLowerCase(),
      )
    ) {
      setEditModalBillOfLadingOpen(true);
    } else {
      showMessage(
        "error",
        translations.title_error,
        translations.errorEditPedido,
      );
    }
  };

  const EliminarBillOfLading = async (idBillOfLading) => {
    try {
      const response = await fetchWithAuth(
        `${API_URL}/api/borrarbl/${idBillOfLading}`,
        {
          method: "DELETE",
        },
      );
      const data = await response.json();
      if (data.codigo === 0) {
        showMessage(
          "success",
          translations.text_Confirmacion,
          translations.BillOfLadingeliminado,
        );
        setBillOfLadings((prev) =>
          prev.filter((bl) => bl.id_bl !== idBillOfLading),
        );
        setFilteredBillOfLadings((prev) =>
          prev.filter((bl) => bl.id_bl !== idBillOfLading),
        );
      } else {
        showMessage(
          "error",
          translations.title_error,
          `${translations.error_eliminarBillOfLading}: ${data.mensaje}`,
        );
      }
    } catch (err) {
      showMessage(
        "error",
        translations.title_error,
        `${translations.error_eliminarBillOfLading}: ${err.message}`,
      );
    }
  };

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchText(value);

    const filtered = billOfLadings.filter((billOfLading) => {
      return (
        (billOfLading.sNroBillOfLading &&
          billOfLading.sNroBillOfLading.toLowerCase().includes(value)) ||
        (billOfLading.mDescripcion &&
          billOfLading.mDescripcion.toLowerCase().includes(value)) ||
        (billOfLading.sSerial &&
          billOfLading.sSerial.toLowerCase().includes(value))
      );
    });

    setFilteredBillOfLadings(filtered);
  };

  const actionTemplate = (rowData) => (
    <Button
      id={`btn-bl-asociar-${rowData.id_bl}`}
      icon="pi pi-pen-to-square"
      className="p-button-rounded p-button-info"
      onClick={() => {
        setSelectedBillOfLading(rowData);
        setAsociarModalOpen(true);
      }}
      tooltip={translations.AsociarPedidoBillOfLading}
      tooltipOptions={{ position: "top" }}
    />
  );

  const [isAsociarModalOpen, setAsociarModalOpen] = useState(false);

  const cargarBillOfLading = () => {
    fetchWithAuth(`${API_URL}/api/billoflading`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Error en la respuesta del servidor al cargar BLs");
        }
        return response.json();
      })
      .then((data) => {
        const processedData = Array.isArray(data) ? data : [];
        setBillOfLadings(processedData);
        setFilteredBillOfLadings(processedData);
      })
      .catch((err) => {
        console.error("Error al cargar los BillOfLading:", err);
      });
  };

  const crearBillOfLading = async () => {
    try {
      const response = await fetchWithAuth(`${API_URL}/api/nuevobl`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`Error en la solicitud: ${response.status}`);
      }

      const data = await response.json();

      if (data.codigo === 0) {
        showMessage(
          "success",
          translations.text_Confirmacion,
          translations.BillOfLadingcreado,
        );
        cargarBillOfLading();
      } else {
        showMessage(
          "error",
          translations.title_error,
          `${translations.error_crearBillOfLading}: ${data.mensaje}`,
        );
      }
    } catch (err) {
      console.error("Error al crear BillOfLading:", err.message);
    }
  };

  return (
    <>
      <Toast ref={toastCenter} position="top-center" baseZIndex={9999} />
      <ConfirmDialog />
      <div className="BillOfLadingprincipal">
        <h1 className="titulo">{translations.GestionBillOfLading}</h1>
        <div className="botonessuperiores">
          <Button
            id="btn-bl-crear"
            label={translations.CrearBillOfLading}
            icon="pi pi-plus"
            className="p-button-success"
            onClick={crearBillOfLading}
          />

          <Button
            id="btn-bl-editar"
            label={translations.BotonEditarBillOfLading}
            icon="pi pi-pencil"
            className="p-button-warning"
            onClick={handleEditBillOfLading}
            disabled={!selectedBillOfLading}
          />

          <Button
            id="btn-bl-eliminar"
            label={translations.BotonEliminarBillOfLading}
            icon="pi pi-delete-left"
            className="p-button-danger"
            disabled={!selectedBillOfLading}
            onClick={() => {
              if (
                selectedBillOfLading &&
                selectedBillOfLading.NombreEstado &&
                ["Creado"].includes(
                  selectedBillOfLading.NombreEstado.toLowerCase(),
                )
              ) {
                showMessage(
                  "error",
                  translations.estadoincorrecto,
                  translations.estado_eliminar_BillOfLading,
                );
                return;
              }
              confirmDialog({
                message: translations.mje_eliminar_BillOfLading,
                header: translations.text_Confirmacion,
                icon: "pi pi-question-circle",
                acceptClassName: "p-button-primary",
                rejectClassName: "p-button-outlined",
                acceptLabel: translations.yesbutton,
                rejectLabel: translations.nobutton,
                accept: () => EliminarBillOfLading(selectedBillOfLading.id_bl),
                reject: () =>
                  showMessage(
                    "info",
                    translations.accioncancelada,
                    translations.accioncancelada,
                  ),
              });
            }}
          />
        </div>

        {isAsociarModalOpen && selectedBillOfLading && (
          <AsociarPedBillOfLadingModal
            language={language}
            isOpen={isAsociarModalOpen}
            initialData={selectedBillOfLading}
            onClose={() => setAsociarModalOpen(false)}
          />
        )}

        {isEditModalBillOfLadingOpen && selectedBillOfLading && (
          <EditarBillOfLadingModal
            isOpen={isEditModalBillOfLadingOpen}
            initialData={selectedBillOfLading}
            language={language}
            onClose={(success) => {
              setEditModalBillOfLadingOpen(false);
              setSelectedBillOfLading(null);
              if (success) {
                cargarBillOfLading();
                showMessage(
                  "success",
                  translations.text_Confirmacion,
                  translations.actualizacion_exitosa,
                );
              }
            }}
          />
        )}

        <div
          className="BillOfLading-lista-BillOfLading"
          style={{ width: "90%", margin: "0 auto" }}
        >
          <div style={{ marginBottom: "20px", textAlign: "center" }}>
            <input
              id="filtro-bl-search"
              type="text"
              placeholder={translations.searchPlaceholder}
              value={searchText}
              onChange={handleSearch}
              style={{ padding: "5px", width: "200px" }}
            />
          </div>

          <DataTable
            value={filteredBillOfLadings}
            paginator
            rows={10}
            responsiveLayout="scroll"
            selectionMode="single"
            sortMode="multiple"
            sortField="IdBillOfLading"
            sortOrder={-1}
            stripedRows
            showGridlines
            removableSort
            className="tabla-lista-BillOfLading"
            selection={selectedBillOfLading}
            onSelectionChange={(e) => setSelectedBillOfLading(e.value)}
          >
            {columnsBillOfLading.map((col, index) => (
              <Column
                key={index}
                field={col.field}
                header={col.header}
                body={(rowData) => {
                  let content = rowData[col.field];
                  if (["FechaEmision"].includes(col.field)) {
                    content = Formatofecha(rowData[col.field]);
                  } else if (
                    col.field === "Shipper" &&
                    (!rowData[col.field] ||
                      String(rowData[col.field]).trim() === "")
                  ) {
                    content = "-";
                  }
                  return (
                    <span id={`bl-celda-${rowData.id_bl}-${col.field}`}>
                      {content}
                    </span>
                  );
                }}
                sortable
              />
            ))}

            <Column header={translations.Acciones} body={actionTemplate} />
          </DataTable>
        </div>
      </div>
    </>
  );
};

export default ListaBillOfLading;
